import React, { useEffect, useState, useContext, useRef } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";

import "antd/dist/antd.min.css";
import { Modal } from "react-bootstrap";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import { confirmAlert } from "react-confirm-alert";
import Badge from "react-bootstrap/Badge";
import Tooltip from "@mui/material/Tooltip";

//Global State import
import { useAtom } from "jotai";
import { gbState } from "../../../../components/shared/GlobalState";

import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import toast from "react-hot-toast";
//Context import
import AuthContext from "../../../../components/shared/Context";

// Add this import for Dropdown components
import { Dropdown, FormControl } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { method } from "lodash";

const FindProductInventoryChild = () => {
  const [productOptions, setProductOptions] = useState();
  const [searchProduct, setSearchProduct] = useState();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [{ errorLogApi, sanitizeInput }] = useAtom(gbState);
  const searchRef = useRef();
  const [data, setData] = useState([]);
  const [unfilteredData, setUnfilteredData] = useState([]);
  const [expiredProducts, setExpiredProducts] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState({});
  // Add these new states
  const [searchText, setSearchText] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);

  // Add new state for keyboard navigation
  const [selectedIndex, setSelectedIndex] = useState(-1);

  // Add ref for suggestions container
  const suggestionsRef = useRef(null);

  const calculateDaysLeft = (date) => {
    // Convert the given date string to a Date object
    const givenDate = new Date(date);

    // Calculate the difference between the current date and the given date in milliseconds
    const timeDiff = givenDate.getTime() - new Date().getTime();

    // Convert milliseconds to days and round down to the nearest integer
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

    // Update the state with the number of days left
    //setDaysLeft(days);
    return days;
  };

  //get all Products
  const getProductsDataFromServer = () => {
    let userToken = localStorage.getItem("token");

    let product_url = `${process.env.REACT_APP_API_URL}/product/${loggedInUserDetails.state}`;

    if (loggedInUserDetails.role === "FULL_ACCESS") {
      product_url = `${process.env.REACT_APP_API_URL}/product/`;
    }

    const config = {
      method: "GET",
      url: product_url,
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    };

    axios(config)
      .then(function (response) {
        // console.log(JSON.stringify(response.data.product));
        const oldData = response.data.product;
        const updatedData = oldData.map((data) => {
          return {
            value: data?._id,
            label: data?.products?.product_name,
            item_code: data?.products?.item_code,
          };
        });
        //console.log(updatedData);
        setProductOptions(updatedData);
      })
      .catch(function (error) {
        errorLogApi(error, "FindProductInventory", "/find-products");
        console.log(error);
      });
  };

  useEffect(() => {
    getProductsDataFromServer();
  }, []);

  const displayLabels = (jsonData) => {
    if (jsonData) {
      let jsonDataparsed = JSON.parse(jsonData);

      // Map over the jsonData to extract only the label of each item
      const labels = jsonDataparsed?.map((item) => item?.label);

      // Join all labels with a comma and a space
      return labels.join(", ");
    }
  };

  // Filter products based on search text
  const filteredProducts = productOptions?.filter((product) => {
    const searchLower = searchText.toLowerCase();
    return (
      product.label.toLowerCase().includes(searchLower) ||
      product.item_code.toLowerCase().includes(searchLower)
    );
  });

  // Handle product selection
  const handleSelect = (product) => {
    setSearchProduct(product);
    setSearchText(product.label);
    setShowDropdown(false);
  };

  // Add this new function
  const handleSearch = () => {
    if (!searchProduct) {
      toast.error("Please select a product from the suggestions");
      return;
    }
    // Here you can add your search logic
    console.log("Searching for product:", searchProduct);
    // You might want to navigate to a details page or trigger another action
  };

  // Add clear function
  const handleClear = () => {
    setSearchText("");
    setSearchProduct(null);
    setShowDropdown(false);
  };

  // Handle keyboard navigation
  const handleKeyDown = (e) => {
    if (!showDropdown || !filteredProducts?.length) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setSelectedIndex((prev) =>
          prev < filteredProducts.length - 1 ? prev + 1 : prev
        );
        break;
      case "ArrowUp":
        e.preventDefault();
        setSelectedIndex((prev) => (prev > 0 ? prev - 1 : -1));
        break;
      case "Enter":
        e.preventDefault();
        if (selectedIndex >= 0) {
          handleSelect(filteredProducts[selectedIndex]);
        } else {
          handleSearch();
        }
        break;
      case "Escape":
        setShowDropdown(false);
        setSelectedIndex(-1);
        break;
      default:
        break;
    }
  };

  // Scroll selected item into view
  useEffect(() => {
    if (selectedIndex >= 0 && suggestionsRef.current) {
      const selectedElement = suggestionsRef.current.children[selectedIndex];
      if (selectedElement) {
        selectedElement.scrollIntoView({ block: "nearest" });
      }
    }
  }, [selectedIndex]);

  // Reset selected index when filtered products change
  useEffect(() => {
    setSelectedIndex(-1);
  }, [searchText]);

  //search the product based on itemcode from API
  useEffect(() => {
    //Get Current Stock
    const getCurrentStockDataFromServer = () => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };

      let urlLink = `${process.env.REACT_APP_API_URL}/tcstock/itemcode/${searchProduct?.item_code}`;

      axios
        .get(urlLink, config)
        .then((res) => {
          const oldData = res?.data?.current_stock;
          //console.log(oldData);
          const updatedData = oldData?.map((data) => {
            //   console.log(data.purchase_inventory.product_id.products);
            return {
              ...data,
              id: data?._id,
              product_name:
                data?.current_stock?.product_id?.products?.product_name,
              category:
                data?.current_stock?.product_id?.products?.category_id
                  ?.category,
              item_code: data?.current_stock?.item_code,
              opening_stock:
                data?.current_stock?.opening_stock +
                " " +
                data?.current_stock?.product_id?.products?.storage_unit,
              purchase_qty:
                data?.current_stock?.purchase_qty +
                " " +
                data?.current_stock?.product_id?.products?.storage_unit,
              sale_qty:
                data?.current_stock?.sale_qty +
                " " +
                data?.current_stock?.product_id?.products?.storage_unit,
              expired_qty:
                "0 " + data?.current_stock?.product_id?.products?.storage_unit,
              useable_closing_qty:
                data?.current_stock?.closing_stock +
                " " +
                data?.current_stock?.product_id?.products?.storage_unit,
              closing_stock:
                data?.current_stock?.closing_stock +
                " " +
                data?.current_stock?.product_id?.products?.storage_unit,
              state: data?.current_stock?.tc_id?.tcenters?.state,
              tc_name: data?.current_stock?.tc_id?.tcenters?.name_tc,
              tc_code:
                data?.current_stock?.tc_id?.tcenters?.treatment_center_id,
              updatedAt: data?.updatedAt,
            };
          });
          //console.log(updatedData);
          setData(updatedData);
          setUnfilteredData(updatedData);
        })
        .catch((err) => console.log("error", err));
    };

    getCurrentStockDataFromServer();
  }, [searchProduct?.item_code]);

  //get Expired product per TC
  useEffect(() => {
    //Get Expired Product Data
    const getExpiredProductsData = async (item_code, tc_id) => {
      try {
        const config = {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        };

        let urlLink = `${process.env.REACT_APP_API_URL}/tcpwstock/single/${item_code}/${tc_id}`;

        const res = await axios.get(urlLink, config);
        const oldData = res.data.product_stock;

        if (!Array.isArray(oldData)) {
          return [];
        }

        const ExpiredProduct = oldData.filter((product) => {
          return (
            product?.product_stock &&
            calculateDaysLeft(product.product_stock.expiry_date) <= 0
          );
        });

        // Return simplified data structure with tc_id and quantities
        return ExpiredProduct.map((data) => ({
          tc_id: data?.product_stock?.tc_id?._id,
          quantity: parseInt(data?.product_stock?.quantity) || 0,
          item_code: data?.product_stock?.item_code,
        }));
      } catch (err) {
        console.error("Error fetching expired products:", err);
        return [];
      }
    };

    const fetchAllExpiredProducts = async () => {
      try {
        if (!Array.isArray(data) || data.length === 0) {
          setExpiredProducts([]);
          return;
        }

        const expiredProductsPromises = data
          .filter((d) => d?.current_stock?.tc_id?._id)
          .map((d) =>
            getExpiredProductsData(
              searchProduct?.item_code,
              d.current_stock.tc_id._id
            )
          );

        const expiredProductsResults = await Promise.all(
          expiredProductsPromises
        );
        const allExpiredProducts = expiredProductsResults.flat();

        // Group and sum quantities by TC ID using a temporary object
        const tempGrouped = allExpiredProducts.reduce((acc, product) => {
          if (product.tc_id) {
            if (!acc[product.tc_id]) {
              acc[product.tc_id] = {
                tc_id: product.tc_id,
                total_expired: 0,
                item_code: product.item_code,
              };
            }
            acc[product.tc_id].total_expired += product.quantity;
          }
          return acc;
        }, {});

        // Convert the grouped object to an array
        const expiredProductsArray = Object.values(tempGrouped);

        setExpiredProducts(expiredProductsArray);
      } catch (error) {
        console.error("Error in fetchAllExpiredProducts:", error);
        setExpiredProducts([]);
      }
    };

    if (data?.length > 0 && searchProduct?.item_code) {
      fetchAllExpiredProducts();
    } else {
      setExpiredProducts([]);
    }
  }, [data, searchProduct?.item_code]);

  //Set expired product now
  useEffect(() => {
    if (expiredProducts?.length > 0 && data?.length > 0) {
      const updatedData = [...data]; // Create a shallow copy of data array

      expiredProducts.forEach((expiredProduct) => {
        let storageUnit;
        // Find the matching item index in data array
        const itemIndex = updatedData.findIndex(
          (d) => d?.current_stock?.tc_id?._id === expiredProduct.tc_id
        );

        // If found, update the expired_qty directly
        if (itemIndex !== -1) {
          updatedData[itemIndex].expired_qty =
            expiredProduct.total_expired +
            " " +
            updatedData[itemIndex]?.current_stock?.product_id?.products
              ?.storage_unit;

          updatedData[itemIndex].useable_closing_qty =
            parseInt(updatedData[itemIndex]?.closing_stock) -
            parseInt(expiredProduct.total_expired) +
            " " +
            updatedData[itemIndex]?.current_stock?.product_id?.products
              ?.storage_unit;
        }
      });
    }
  }, [expiredProducts]);

  const useStyles = makeStyles(() => ({
    multiLineCell: {
      display: "flex",
      wordBreak: "keep-all",
      wordWrap: "break-word",
      overflowWrap: "break-word",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      lineHeight: "1.2rem",
      height: "auto",
    },
  }));

  const MultiLineCellRenderer = (params) => {
    const classes = useStyles();
    return (
      <Tooltip title={params.row.product_name}>
        <div className={classes.multiLineCell}>
          <span id="content1" className="text-bold">
            {params.row.tc_name}
          </span>
          <span id="content2">
            <small className=" small-font-size">{params.row.tc_code}</small>
          </span>
        </div>
      </Tooltip>
    );
  };

  const columns = [
    {
      field: "tc_name",
      headerName: "Treatment Center",
      disableColumnMenu: true,
      width: 170,
      renderCell: MultiLineCellRenderer,
    },
    // {
    //   field: "opening_stock",
    //   headerName: "Opening Stock",
    //   width: 160,
    //   filterable: false,
    //   disableColumnMenu: true,
    //   align: "center",
    // },
    // {
    //   field: "purchase_qty",
    //   headerName: "Alloted",
    //   width: 110,
    //   filterable: false,
    //   sortable: true,
    //   disableColumnMenu: true,
    //   align: "center",
    // },
    // {
    //   field: "sale_qty",
    //   headerName: "Consumed",
    //   width: 130,
    //   filterable: false,
    //   sortable: true,
    //   disableColumnMenu: true,
    //   align: "center",
    // },
    {
      field: "expired_qty",
      headerName: "Expired",
      width: 130,
      filterable: false,
      sortable: true,
      disableColumnMenu: true,
      align: "center",
      renderCell: (params) => {
        // Extract numeric value from string like "120 vial(s)"
        const numericValue = parseInt(params?.row?.expired_qty?.split(" ")[0]);
        return (
          <Badge
            bg={numericValue > 0 ? "danger" : "success"}
            style={{ width: "100%", display: "block", fontSize: "0.8rem" }}
          >
            {params?.row?.expired_qty}
          </Badge>
        );
      },
    },
    //useable_closing_qty
    {
      field: "useable_closing_qty",
      headerName: "Available Stock",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
      renderCell: (params) => (
        <div style={{ fontWeight: "bold" }}>
          {params.row.useable_closing_qty}
        </div>
      ),
    },
    {
      field: "closing_stock",
      headerName: "Total Closing",
      width: 160,
      filterable: false,
      disableColumnMenu: true,
      align: "center",
    },
    {
      field: "state",
      headerName: "State",
      width: 110,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 180,
      filterable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => (
        <Button
          variant="success"
          size="sm"
          onClick={() => {
            // Add transfer request logic here
            setCurrentRecord(params.row);
            setOpenModal(true);
          }}
        >
          <i className="mdi mdi-transfer me-1"></i>
          Request for transfer
        </Button>
      ),
    },
  ];

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="position-relative">
            <InputGroup className="mb-3">
              <FormControl
                placeholder="Search by product name or item code..."
                value={searchText}
                onChange={(e) => {
                  setSearchText(e.target.value);
                  setShowDropdown(true);
                }}
                onKeyDown={handleKeyDown}
                disabled={!productOptions}
                className="form-control-lg"
              />
              {searchText && (
                <Button
                  variant="outline-secondary"
                  onClick={handleClear}
                  className="position-absolute"
                  style={{
                    right: "110px", // Positions it before the Search button
                    zIndex: 10,
                    border: "none",
                    background: "transparent",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                >
                  ✕
                </Button>
              )}
              <Button
                variant="primary"
                size="lg"
                onClick={handleSearch}
                disabled={!productOptions}
              >
                Search
              </Button>
            </InputGroup>

            {showDropdown && searchText && (
              <div
                ref={suggestionsRef}
                className="position-absolute w-100 shadow-lg"
                style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  zIndex: 1000,
                  backgroundColor: "white",
                  borderRadius: "8px",
                  border: "1px solid #dee2e6",
                }}
              >
                {filteredProducts?.map((product, index) => (
                  <div
                    key={product.value}
                    className={`p-3 border-bottom hover-bg ${
                      selectedIndex === index ? "bg-light" : ""
                    }`}
                    onClick={() => handleSelect(product)}
                    style={{ cursor: "pointer" }}
                    onMouseEnter={(e) => {
                      setSelectedIndex(index);
                      e.currentTarget.style.backgroundColor = "#f8f9fa";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        selectedIndex === index ? "#f8f9fa" : "white";
                    }}
                  >
                    <div className="fw-bold">{product.label}</div>
                    <div className="text-muted small">
                      Item Code: {product.item_code}
                    </div>
                  </div>
                ))}
                {filteredProducts?.length === 0 && (
                  <div className="p-3 text-center text-muted">
                    No products found
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="col-12">
          {data?.length ? (
            <div className="card shadow-sm">
              <div className="card-body p-0">
                <DataGrid
                  rows={data}
                  disableSelectionOnClick
                  columns={columns}
                  pageSize={10}
                  rowsPerPageOptions={[10, 25, 50]}
                  displayTitle="Current Stocks"
                  checkboxSelection
                  style={{ height: "60vh", border: "none" }}
                  className="rounded-3"
                />
              </div>
            </div>
          ) : (
            <div className="text-center text-muted py-5">
              <i className="fas fa-search fa-2x mb-3"></i>
              <p className="mb-0">
                Please search for a product to view inventory of other TCs
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Modal Popup */}
      <Modal show={openModal} centered>
        <Modal.Header closeButton onClick={() => setOpenModal(false)}>
          <Modal.Title>Request Detail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModalContent
            currentRecord={currentRecord}
            setOpenModal={setOpenModal}
          />
        </Modal.Body>
      </Modal>
    </div>
  );
};

const ModalContent = ({ currentRecord, setOpenModal }) => {
  const { loggedInUserDetails } = useContext(AuthContext);

  // Initialize formData with proper structure
  const [formData, setFormData] = useState({
    product_id: currentRecord?.current_stock?.product_id?._id || null,
    requested_quantity: "",
    request_to_tc_id: currentRecord?.current_stock?.tc_id?._id || null,
    requester_comments: "",
  });

  // Log initial values
  useEffect(() => {
    console.log("Current Record:", currentRecord);
    console.log("Initial FormData:", formData);
  }, []);

  const handleChange = (event) => {
    const { name, value, type } = event.target;

    console.log("Input Change - Name:", name, "Value:", value); // Debug log

    setFormData((prevData) => {
      const newData = {
        ...prevData,
        [name]:
          type === "number" ? (value === "" ? "" : parseInt(value)) : value,
      };
      console.log("Updated FormData:", newData); // Debug log
      return newData;
    });
  };

  const handleSubmit = () => {
    // Validate requested quantity
    if (!formData.requested_quantity) {
      toast.error("Please enter requested quantity");
      return;
    }

    // Check if requested quantity exceeds available quantity
    if (
      parseInt(formData.requested_quantity) >
      parseInt(currentRecord?.useable_closing_qty)
    ) {
      toast.error("Requested quantity cannot exceed available quantity");
      return;
    }

    // Validate requested quantity is positive
    if (parseInt(formData.requested_quantity) <= 0) {
      toast.error("Please enter a valid quantity greater than 0");
      return;
    }
    // Validate comments/reason
    if (
      !formData.requester_comments ||
      formData.requester_comments.trim() === ""
    ) {
      toast.error("Please provide comments or reason for the request");
      return;
    }

    // Continue with submit logic...
    let urlLink = `${process.env.REACT_APP_API_URL}/tc-prod-request/add`;
    const config = {
      method: "POST",
      url: urlLink,
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      data: { ...formData },
    };

    axios(config)
      .then((res) => {
        toast.success("Request created sucessfully!");
        setOpenModal(false);
      })
      .catch((err) => console.log("error", err));
  };

  return (
    <div className="">
      <div className="mb-4">
        <div className="p-3 bg-secondary text-white rounded-3 mb-3">
          <h5 className="mb-1 text-white">
            {currentRecord?.current_stock?.tc_id?.tcenters?.name_tc}
          </h5>
          <small>
            TC ID:{" "}
            {currentRecord?.current_stock?.tc_id?.tcenters?.treatment_center_id}
          </small>
        </div>

        {/* <h5 className="text-primary mb-3">Product Details</h5> */}
        <div className="p-4 bg-light rounded-3 border shadow-sm">
          <div className="row mb-3">
            <div className="col-4">
              <span className="text-muted">Product Name:</span>
            </div>
            <div className="col-8">
              <span className="fw-bold">
                {
                  currentRecord?.current_stock?.product_id?.products
                    ?.product_name
                }
              </span>
            </div>
          </div>
          <div className="row">
            <div className="col-4">
              <span className="text-muted">Item Code:</span>
            </div>
            <div className="col-8">
              <span className="fw-bold">
                {currentRecord?.current_stock?.product_id?.products?.item_code}
              </span>
            </div>
          </div>
        </div>
      </div>
      <Form>
        <Form.Group className="mb-3">
          <Form.Label>Available Quantity</Form.Label>
          <Form.Control
            type="text"
            value={currentRecord?.useable_closing_qty}
            disabled
            className="bg-light"
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Request Quantity</Form.Label>
          <Form.Control
            type="number"
            name="requested_quantity"
            placeholder="Enter quantity needed"
            value={formData.requested_quantity}
            onChange={handleChange}
            min="1"
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Comments / Reason</Form.Label>
          <Form.Control
            as="textarea"
            name="requester_comments"
            rows={3}
            placeholder="Enter any additional comments"
            value={formData.requester_comments}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <div className="d-flex justify-content-end">
          <Button
            variant="primary"
            size="sm"
            onClick={handleSubmit}
            disabled={
              !formData.requested_quantity || !formData.requester_comments
            }
          >
            Submit Request
          </Button>
        </div>

        {/* Debug display */}
        {/* <div className="mt-3">
          <pre>{JSON.stringify(formData, null, 2)}</pre>
        </div> */}
      </Form>
    </div>
  );
};

export default FindProductInventoryChild;
